export default __webpack_public_path__ + "static/media/hotel_img_hi_03.940c1aa2.jpg";